import React, { useState, useEffect } from 'react'
import { getDealerMappedinAMuAgentBycommId, SaveUpdatedMappedDealer } from '../Community/CommunityActionCreator'
import Loader from '../../../../presentationals/Loader/Loader.component'
import PopUp from '../../../../presentationals/Popup/Popup.component'

const itemsPerPage = 10;
export default function Mapped({ ParentcommunityId }) {
    const [TableData, setTableData] = useState([])
    const [FilteredTableData, setFilteredTableData] = useState([])
    const [loader, setloader] = useState(false)
    const [popup, setpopup] = useState({ show: false, popupStatus: '' })
    const [viewScreen, setviewScreen] = useState("Mapped");
    const [currentPage, setcurrentPage] = useState(1);
    const [searchfield, setsearchfield] = useState("")

    
    const handlePage = (type) => {
        setviewScreen(type)
        setcurrentPage(1)
        setsearchfield("")
        getDealerMappedinAMuAgentBycommIdFunction(type)
    }

    useEffect(() => {
        getDealerMappedinAMuAgentBycommIdFunction(viewScreen)
    }, [])

    const getDealerMappedinAMuAgentBycommIdFunction = (viewType) => {
        const isMapped = viewType === "Mapped" ? true : false
        setloader(true)
        getDealerMappedinAMuAgentBycommId(ParentcommunityId, isMapped, "", (callback) => {
            console.log("call", callback)
            setloader(false)
            if (callback && callback?.message == "success" && callback?.status == 200) {
                setTableData(callback?.data)
                filterDataByPage(callback?.data, 1)
                setcurrentPage(1);
            } else {
                setTableData([])
                setFilteredTableData([])
            }
        })
    }


    const handleToggle = (id) => {
        const data = {
            "parentCommunityId": ParentcommunityId,
            "communityId": id,
            "mappedOrNot": viewScreen === "Mapped" ? false : true
        }
        setloader(true)
        SaveUpdatedMappedDealer(data, (callback) => {
            setloader(false)
            console.log("call", callback)
            if (callback && callback?.status == 200 && callback?.message == "success") {
                if (viewScreen === "Mapped") {
                    setpopup({ show: true, popupStatus: "Dealer UnMapped Successfully" })
                } else {
                    setpopup({ show: true, popupStatus: "Dealer Mapped Successfully" })
                }
                getDealerMappedinAMuAgentBycommIdFunction(viewScreen)
            } else {
                setpopup({ show: true, popupStatus: "Failure" })
            }
            removePopup()
        })
    }
    const closePopup = () => {
        setpopup({ show: false, popupStatus: '' })
    }

    const removePopup = () => {
        setTimeout(() => {
            closePopup()
        }, 5000)
    }

    const getFilteredData = () => {
        if (!searchfield) return TableData;

        return TableData.filter((item) =>
            item?.communityName?.toLowerCase().includes(searchfield)
        );
    };

    const paginationHandler = (type) => {
       const data = getFilteredData();
    const totalPages = Math.ceil(data.length / itemsPerPage);
    
    if (type === 'left') {
        if (currentPage > 1) {
            setcurrentPage((prev) => prev - 1)
            filterDataByPage(data, currentPage - 1)  
        }
    }
    if (type === 'right') {
        if (currentPage < totalPages) {
            setcurrentPage((prev) => prev + 1)
            filterDataByPage(data, currentPage + 1) 
        }
    }
    }

    const filterDataByPage = (data, currentPage) => {
        const startIndex = (currentPage - 1) * itemsPerPage;
        const endIndex = startIndex + itemsPerPage;
        const fData = data.slice(startIndex, endIndex);
        setFilteredTableData(fData)
    };

    useEffect(() => {
        const delay = setTimeout(() => {
            const filtered = getFilteredData();
            filterDataByPage(filtered, 1);
            setcurrentPage(1);
        }, 300);

        return () => clearTimeout(delay);
    }, [searchfield]);

    const handleChangeSearch = (e) => {
        const value = e.target.value.toLowerCase();
        setsearchfield(value);

        const filtered = TableData.filter((item) =>
            item?.communityName?.toLowerCase().includes(value)
        );

        setcurrentPage(1);
        filterDataByPage(filtered, 1);
    };

    return (
        <>
            <div className='container-fluid full-height'>
                {
                    loader ? <Loader /> : ''
                }

                {
                    popup.show == true ? <PopUp popupStatus={popup.popupStatus} closePopup={closePopup} /> : ''
                }
                <div className='row'>
                    <ul className='detail-page-hr-sub-tabs' style={{ paddingTop: '10px', margin: '0' }}>
                        <li className={viewScreen === 'Mapped' ? 'communication-btn-active communication-btn' : 'communication-btn'} style={{ width: '13%' }} onClick={e => handlePage('Mapped')}>Mapped Dealer</li>
                        <li className={viewScreen === 'UnMapped' ? 'communication-btn-active communication-btn' : 'communication-btn'} style={{ width: '13%' }} onClick={e => handlePage('UnMapped')}>Unmapped Dealer</li>
                    </ul>
                </div>

                {
                    viewScreen === 'UnMapped' ?
                        <div className='row' style={{ marginTop: '20px' }}>
                            <div className="col-sm-2 col-xs-12">

                                <label>Search</label>
                                <input className='form-control' type='text' value={searchfield} onChange={(e) => handleChangeSearch(e)} placeholder='Enter Name...' />
                            </div>
                        </div>
                        : ""}

                {FilteredTableData && FilteredTableData?.length > 0 ?
                    <div style={{ marginTop: '30px' }}>
                        <div className='overflow-auto'>
                            <table className='phocket-table'>
                                <thead style={{ backgroundColor: '#182D64' }}>
                                    <tr>
                                        {/* <th>Product Id</th> */}
                                        <th>Community code</th>
                                        <th>Firm Name</th>
                                        <th>Community Name</th>
                                        <th>Mobile Number</th>
                                        <th>Email Id</th>

                                        <th>Dealer Mapped </th>

                                    </tr>
                                </thead>
                                <tbody>
                                    {FilteredTableData?.map((nbfc, i) => {
                                        return (
                                            <>

                                                <tr key={i}>
                                                    {/* <td>{nbfc?.productId || "-"}</td> */}
                                                    <td>{nbfc?.communityCode || "-"}</td>
                                                    <td>{nbfc?.firmName || "-"}</td>
                                                    <td>{nbfc?.communityName || "-"}</td>
                                                    <td>{nbfc?.mobileNo || "-"}</td>
                                                    <td>{nbfc?.email || "-"}</td>

                                                    <td>
                                                        <div className="togglableSwitch">
                                                            <label class="toggle-switch">
                                                                <input type="checkbox"
                                                                    checked={viewScreen === "Mapped" ? true : false}
                                                                    onChange={() => handleToggle(nbfc.communityId)}
                                                                />
                                                                <div class="toggle-switch-background">
                                                                    <div class="toggle-switch-handle"></div>
                                                                </div>
                                                            </label>
                                                        </div>
                                                    </td>
                                                </tr>

                                            </>
                                        )
                                    })}
                                </tbody>
                            </table>
                        </div>
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-sm-5 col-xs-12 no-padding"> <button type="button" className="btn btn-default fa fa-chevron-left btn-lg btn-block mage" style={{ background: 'rgb(24, 45, 100)' }} id="backword" onClick={e => paginationHandler('left')}><span className="fa fa-chevron-left" /></button></div>
                                <div className="col-sm-2 col-xs-12  phoc text-center" >Total: {currentPage}&nbsp; of &nbsp; {Math.ceil(getFilteredData().length / itemsPerPage)}</div>
                                <div className="col-sm-5 col-xs-12 no-padding"> <button type="button" className="btn btn-default fa fa-chevron-right btn-lg btn-block mage" style={{ background: 'rgb(24, 45, 100)' }} id="forword" onClick={e => paginationHandler('right')}><span className="fa fa-chevron-right" /></button></div> </div>
                        </div>
                    </div>
                    : ''}
            </div>
        </>
    )
}
